import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  container: props => ({
    height: theme.spacing(props._size),
    backgroundColor: props.color,
    borderRadius: "0.75rem",
    fontSize: theme.spacing(props._size),
  }),
  content: props => ({
    height: theme.spacing(props._size),
    fontSize: theme.spacing(props._size * 0.75),
    color: "white",
    zIndex: 0,
    paddingLeft: theme.spacing(props._size) * 0.5 + theme.spacing(0.5),
    paddingRight: theme.spacing(props._size) * 0.5 + theme.spacing(0.5),
  }),
}));

const TagComponent = ({ text, color, size }) => {
  const _size = size === "big" ? 3 : 1.5;
  const classes = useStyles({ color, _size });
  return (
    <div className={classes.container}>
      <div className={classes.content}>{text}</div>
    </div>
  );
};

TagComponent.defaultProps = {
  size: "small",
  color: "grey",
};

TagComponent.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
};

export default TagComponent;
